import { render, staticRenderFns } from "./OneMitigationDialog.vue?vue&type=template&id=56811062&scoped=true"
import script from "./OneMitigationDialog.vue?vue&type=script&lang=js"
export * from "./OneMitigationDialog.vue?vue&type=script&lang=js"
import style0 from "./OneMitigationDialog.vue?vue&type=style&index=0&id=56811062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56811062",
  null
  
)

export default component.exports